import { Box, Typography } from '@mui/material';
import { FC, Fragment, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as FailureIconVs } from 'src/assets/svg/failure-red-circle.svg';
import { ReactComponent as FailureIconHos } from 'src/assets/svg/failure-red-circle-hos.svg';
import { getTheme } from 'src/utils/getTheme';

import { styles } from './styles';

const { isHosTheme } = getTheme();

interface BookingFailurePageProps {
    titleKey?: string;
    subtitleKey?: string;
}

const FailureIcon: FC<BookingFailurePageProps> = () =>
    isHosTheme ? <FailureIconHos /> : <FailureIconVs />;

const TextWrapper: FC<{ children: ReactNode }> = (props) => {
    const Wrapper = isHosTheme ? Box : Fragment;

    return <Wrapper>{props.children}</Wrapper>;
};

export const BookingUpdateFailurePage: FC<BookingFailurePageProps> = (props) => {
    const { t } = useTranslation();

    return (
        <Box css={styles.container}>
            <Box css={styles.imageContainer} />

            <Box css={styles.wrapper}>
                <FailureIcon />
                <TextWrapper>
                    <Typography variant="h1" css={styles.title}>
                        {t(props.titleKey ?? 'booking_failure_title')}
                    </Typography>
                    <Typography
                        variant="body3"
                        css={styles.link}
                        dangerouslySetInnerHTML={{
                            __html: t(props.subtitleKey ?? 'booking_update_failure_content'),
                        }}
                    />
                </TextWrapper>
            </Box>
        </Box>
    );
};
